__turbopack_context__.v({
  "active": "HowItWorks-module-scss-module__2HabRW__active",
  "activeWebApp": "HowItWorks-module-scss-module__2HabRW__activeWebApp",
  "fadeInActive": "HowItWorks-module-scss-module__2HabRW__fadeInActive",
  "fadeInActiveAppTab": "HowItWorks-module-scss-module__2HabRW__fadeInActiveAppTab",
  "fadeInActiveGraphics": "HowItWorks-module-scss-module__2HabRW__fadeInActiveGraphics",
  "graphicsCol": "HowItWorks-module-scss-module__2HabRW__graphicsCol",
  "heading": "HowItWorks-module-scss-module__2HabRW__heading",
  "howitWorksRow": "HowItWorks-module-scss-module__2HabRW__howitWorksRow",
  "howitworkWrap": "HowItWorks-module-scss-module__2HabRW__howitworkWrap",
  "imgBox": "HowItWorks-module-scss-module__2HabRW__imgBox",
  "main": "HowItWorks-module-scss-module__2HabRW__main",
  "mobileAppTab": "HowItWorks-module-scss-module__2HabRW__mobileAppTab",
  "nav": "HowItWorks-module-scss-module__2HabRW__nav",
  "navCol": "HowItWorks-module-scss-module__2HabRW__navCol",
  "navWrap": "HowItWorks-module-scss-module__2HabRW__navWrap",
  "playStoreBtn": "HowItWorks-module-scss-module__2HabRW__playStoreBtn",
  "tabBox": "HowItWorks-module-scss-module__2HabRW__tabBox",
  "tabBoxWrap": "HowItWorks-module-scss-module__2HabRW__tabBoxWrap",
  "tabNav": "HowItWorks-module-scss-module__2HabRW__tabNav",
  "tabRow": "HowItWorks-module-scss-module__2HabRW__tabRow",
  "webAppTab": "HowItWorks-module-scss-module__2HabRW__webAppTab",
});
